// extracted by mini-css-extract-plugin
export default {"root":"Card_root__b95qA","card_title":"Card_card_title__2SLwf","card_value":"Card_card_value__LMc+E"};